import { ReactNode } from 'react';

import { Typography } from 'components';

import styles from './AccountField.module.css';
type AccountFieldProps = {
  children: ReactNode;
  title: string;
  action?: () => void;
  actionName?: string;
};
const AccountField = ({
  children,
  title,
  action,
  actionName,
}: AccountFieldProps) => {
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <Typography variant='heading-m' className={styles.title}>
          {title}
        </Typography>
        {action && (
          <span className={styles.action} onClick={action} title={actionName}>
            {actionName}
          </span>
        )}
      </div>
      <div className={styles.group}>{children}</div>
    </div>
  );
};
export default AccountField;
